import { render } from "./NewsFullItem.vue?vue&type=template&id=d05dd26a"
import script from "./NewsFullItem.vue?vue&type=script&lang=js"
export * from "./NewsFullItem.vue?vue&type=script&lang=js"

import "./NewsFullItem.vue?vue&type=style&index=0&id=d05dd26a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__